// Centralized, resilient localStorage access.
// Auth tokens are intentionally kept in localStorage (product decision); wrapping
// every access in try/catch means a blocked or unavailable store never crashes the app.
import { logger } from "@/lib/logger";

export const TOKEN_KEY = "autobus_token";

export function safeGet(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    logger.warn(`storage: unable to read "${key}"`, e);
    return null;
  }
}

export function safeSet(key, value) {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    logger.warn(`storage: unable to write "${key}"`, e);
    return false;
  }
}

export function safeRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    logger.warn(`storage: unable to remove "${key}"`, e);
  }
}
